export default "__VITE_ASSET__ClUPwzgN__"